import type { definitions } from '@luxuryescapes/contract-svc-accommodation'

import { assertUnreachable } from 'lib/staticAssert/staticAssertUtils'

type ServerPromotionType = definitions['PromotionType']

export function mapPromotionType(
  serverPromotionType: ServerPromotionType,
): Pick<App.Property.Promotion, 'type' | 'isCampaign'> {
  const isCampaign = /^campaign(?:\.\w+)?$/.test(serverPromotionType)
  switch (serverPromotionType) {
    case 'campaign.dynamicFlash':
      return { type: 'dynamicFlash', isCampaign }
    case 'campaign':
      return { type: 'campaign', isCampaign }
    case 'campaign.bundle':
    case 'bundle':
      return { type: 'bundle', isCampaign }
    case 'campaign.tactical':
    case 'tactical':
      return { type: 'tactical', isCampaign }
    case 'campaign.marriottPromo':
    case 'bedbank':
      return { type: 'bedbank', isCampaign }
    default:
      assertUnreachable(serverPromotionType)
  }
}
